import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuth } from "../AuthContext.js";
import {Navbar} from "react-bootstrap";
import listaProductos from "./listaProductos";
import POS from "./posProductos";

const Productos = () => {
    const { verificacionToken, removerLocalStorage } = useAuth();
    const [loading, setLoading] = useState(true);

    const [products, setProducts] = useState([]);
    const [view, setView] = useState("list"); // list | form | pos
    const [editProduct, setEditProduct] = useState(null);

    useEffect(() => {
        verificacionToken("ROLE_DUENO");
        setLoading(false);
    }, []);

    const addProduct = (product) => {
        if (editProduct) {
            setProducts(
                products.map((p) => (p.id === editProduct.id ? product : p))
            );
            setEditProduct(null);
        } else {
            setProducts([...products, { ...product, id: Date.now() }]);
        }
        setView("list");
    };

    const handleEdit = (product) => {
        setEditProduct(product);
        setView("form");
    };

    return (
        <div>
            <Navbar setView={setView} />
            <div className="container mt-4">
                {view === "list" && (
                    <listaProductos products={products} onEdit={handleEdit} />
                )}
                {view === "form" && (
                    <listaProductos onSave={addProduct} product={editProduct} />
                )}
                {view === "pos" && <POS products={products} />}
            </div>
        </div>
    );
}

export default Productos;